<template>
    <div>
    <div class="container mt-4 mb-4">
        <!-- <atras-component></atras-component> -->
        <boton-atras :nombre_ruta="'estatal'"></boton-atras>
        <div class="row">
            <div class="col-md  mt-1 order-2 order-sm-2 order-md-1 order-lg-1">
                <h6 class="subtitulo mb-2">Leyes</h6>
                <div class="lineaNegra"></div>
                <div class="mt-1 mb-2 lineaNegra2"></div>
                <a href="https://www.congresochiapas.gob.mx/new/Info-Parlamentaria/LEY_0002.pdf?v=NTc=" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Constitución Política del Estado Libre y Soberano de Chiapas </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>

                <a href="https://www.congresochiapas.gob.mx/new/Info-Parlamentaria/LEY_0065.pdf?v=MzE=" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                            <div class="col-9">
                                <h5> Ley Orgánica de la Administración Pública del Estado de Chiapas </h5>
                            </div>
                            <div class="col-4">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>

                <a href="https://www.congresochiapas.gob.mx/new/Info-Parlamentaria/LEY_0084.pdf?v=OQ==" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Ley de transparencia y acceso a la información pública del Estado de Chiapas </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>

                <a href="https://www.congresochiapas.gob.mx/new/Info-Parlamentaria/LEY_0036.pdf?v=MTE=" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                            <div class="col-9">
                                <h5> Ley de fiscalización y rendición de cuentas del Estado de Chiapas </h5>
                            </div>
                            <div class="col-4">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>

                <a href="https://www.congresochiapas.gob.mx/new/Info-Parlamentaria/LEY_0135.pdf?v=MQ==" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                            <div class="col-9">
                                <h5> Ley de protección de datos personales en posesión de sujetos obligados del Estado de Chiapas </h5>
                            </div>
                            <div class="col-4">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                
                <a href="https://www.congresochiapas.gob.mx/new/Info-Parlamentaria/LEY_0059.pdf?v=NA==" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                            <div class="col-9">
                                <h5> Ley de Archivos del Estado de Chiapas  </h5>
                            </div>
                            <div class="col-4">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <!--  -->
                <!--  -->
                <!--<h4 class="subtitulo2 mt-5">Código de la hacienda pública para el Estado de Chiapas</h4>-->
                <a href="https://www.congresochiapas.gob.mx/new/Info-Parlamentaria/LEY_0007.pdf?v=MzA=" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Código de la hacienda pública para el Estado de Chiapas </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <!--<a :href="urlServe+'marco-juridico/Estatal/informacion/Leyes/libro-primero.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Libro primero, "Régimen de los Ingresos Públicos" </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>

                <a :href="urlServe+'marco-juridico/Estatal/informacion/Leyes/libro-segundo.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                            <div class="col-9">
                                <h5> Libro Segundo, "De las Contribuciones, Productos y Aprovechamientos" <span class="text-muted"><i>(Ley de Hacienda Pública)</i></span> </h5>
                            </div>
                            <div class="col-4">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>

                <a :href="urlServe+'marco-juridico/Estatal/informacion/Leyes/libro-tercero.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Libro Tercero, "De la Coordinación Hacendaria del Estado de Chiapas" <span class="text-muted"><i>(Ley de Hacienda Coordinación Fiscal)</i></span> </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>

                <a :href="urlServe+'marco-juridico/Estatal/informacion/Leyes/libro-cuarto.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                            <div class="col-9">
                                <h5> Libro Cuarto, "Presupuesto, Gasto, Contabilidad y Deuda Pública" <span class="text-muted"><i>(Ley de Deduda Pública)</i></span> </h5>
                            </div>
                            <div class="col-4">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>-->
                <!--  -->
                <!--  -->
                <h4 class="subtitulo2 mt-5">Ley de ingresos del Estado de Chiapas</h4>
                <a href="https://www.congresochiapas.gob.mx/new/Info-Parlamentaria/LEY_0124.pdf?v=Mw==" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                            <div class="col-9">
                                <h5> Ley que establece el proceso de Entrega Recepción de la Administración Pública del Estado de Chiapas  </h5>
                            </div>
                            <div class="col-4">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>

                <a href="https://www.congresochiapas.gob.mx/new/Info-Parlamentaria/LEY_0046.pdf?v=NQ==" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                            <div class="col-9">
                                <h5> Ley de Planeación para el Estado de Chiapas  </h5>
                            </div>
                            <div class="col-4">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>

                <a href="https://www.congresochiapas.gob.mx/new/Info-Parlamentaria/ley%20de%20entidades%20paraestatales%20del%20estado%20de%20chiapas.pdf?v=Mw==" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                            <div class="col-9">
                                <h5> Ley de Entidades Paraestatales del Estado de Chiapas </h5>
                            </div>
                            <div class="col-4">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>

                <!--<a :href="urlServe+'marco-juridico/Estatal/informacion/Leyes/fiscalizacion.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                            <div class="col-9">
                                <h5> Ley de Fiscalización Superior del Estado de Chiapas </h5>
                            </div>
                            <div class="col-4">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>-->

                <a href="https://www.congresochiapas.gob.mx/new/Info-Parlamentaria/LEY_0020.pdf?v=NA==" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                            <div class="col-9">
                                <h5> Ley de Catastro para el Estado de Chiapas </h5>
                            </div>
                            <div class="col-4">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>       

                <a href="https://www.congresochiapas.gob.mx/new/Info-Parlamentaria/LEY_0086.pdf?v=Nw==" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                            <div class="col-9">
                                <h5> Ley de Establecimientos Mutuantes del Estado de Chiapas </h5>
                            </div>
                            <div class="col-4">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>

                <a href="https://www.congresochiapas.gob.mx/new/Info-Parlamentaria/LEY_0061.pdf?v=MjA=" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                            <div class="col-9">
                                <h5> Ley de Derechos del Estado de Chiapas </h5>
                            </div>
                            <div class="col-4">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>

                <a href="https://www.congresochiapas.gob.mx/new/Info-Parlamentaria/LEY_0016.pdf?v=OA==" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                            <div class="col-9">
                                <h5> Ley de Adquisiciones, Arrendamiento de Bienes Muebles y Contratación de Servicios para el Estado de Chiapas </h5>
                            </div>
                            <div class="col-4">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>

                <a href="https://www.congresochiapas.gob.mx/new/Info-Parlamentaria/LEY_0044.pdf?v=Ng==" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                            <div class="col-9">
                                <h5> Ley de Obra Pública del Estado de Chiapas </h5>
                            </div>
                            <div class="col-4">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>

                <a href="https://www.congresochiapas.gob.mx/new/Info-Parlamentaria/LEY_0052.pdf?v=NA==" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                            <div class="col-9">
                                <h5> Ley de Asociaciones Público Privadas para el Estado de Chiapas </h5>
                            </div>
                            <div class="col-4">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>

                <a href="https://www.congresochiapas.gob.mx/new/Info-Parlamentaria/LEY_0128.pdf?v=Mw==" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                            <div class="col-9">
                                <h5> Ley del Sistema Anticorrupción del Estado de Chiapas </h5>
                            </div>
                            <div class="col-4">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>

                <a href="https://www.congresochiapas.gob.mx/new/Info-Parlamentaria/LEY_0131.pdf?v=NA==" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                            <div class="col-9">
                                <h5> Ley de Responsabilidades Administrativas para el Estado de Chiapas  </h5>
                            </div>
                            <div class="col-4">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>

                <!--  -->
                <!-- DECRETOS -->
                <!--  -->
                <h6 class="subtitulo mt-5">Decretos</h6>
                <div class="lineaNegra"></div>
                <div class="mt-1 mb-2 lineaNegra2"></div>

                <h4 class="subtitulo2 mt-3">Presupuesto de Egresos del Estado de Chiapas</h4>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Decretos/decretos-coeficientes.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                            <div class="col-9">
                                <h5> Decreto que contiene bases, coeficientes y plazos para el pago de participaciones fiscales Federales a los Municipios del Estado de Chiapas para el Ejercicio Fiscal 2009   </h5>
                            </div>
                            <div class="col-4">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>

                <a :href="urlServe+'marco-juridico/Estatal/informacion/Decretos/decretos-sectorizacion.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                            <div class="col-9">
                                <h5> Decreto de sectorización de entidades de la administración publica del Estado de Chiapas </h5>
                            </div>
                            <div class="col-4">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>

                <a :href="urlServe+'marco-juridico/Estatal/informacion/Decretos/decreto-austeridad.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                            <div class="col-9">
                                <h5> Decreto que establece Medida de Austeridad, Disciplina y Racionalidad del Gasto, así como, la Operatividad de la Comisión Intersecretarial de Gasto Financiamiento del Gobierno del Estado </h5>
                            </div>
                            <div class="col-4">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>

                <!--<a :href="urlServe+'marco-juridico/Estatal/leyes-decretos-historial.asp'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                            <div class="col-9">
                                <h5>Ir a Historial 1982-2005 </h5>
                            </div>
                            <div class="col-4">
                                <p class="descargar">Enlace <i class='bx bx-link icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>-->


            </div>

            <div class="col-md order-1 order-sm-1 order-md-2 order-lg-2 ">
                <div class="row margenes">
                    <div class="sec_imagen">
                        <img src="@/assets/imagenes/leyesMunicipal.jpg" alt="">
                    </div>
                </div>
                <!--  -->
                <!--  -->
                <div class="row mt-4 row margenes tab-select">
                    <!-- <div class="card card-width">
                        <div class="card-body">
                            <h4 class="subtitulo2">Ley de ingresos del Estado de Chiapas</h4>
                            <div class="row">
                                <div class="col-7">
                                    <select class="form-control form-control-lg">
                                        <option>Consultar año</option>
                                        <option value="">2004</option>
                                        <option value="">2005</option>
                                        <option value="">2006</option>
                                    </select>
                                </div>
                                <div class="col-5">
                                    <button class="btn btn-vino btn-block">Consultar</button>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <!--  -->
                    <!-- <div class="row mt-3"> -->
                        <leyes-decretos-collapse></leyes-decretos-collapse>
                    <!-- </div> -->


                </div>

            </div>
        </div>
    </div>
     <div class="text-aviso my-5">
        <h5> <span class="resaltado-vino">AVISO:</span> Los instrumentos jurídicos que se mencionan a continuación, son solo de referencia, encontrándose para su consulta oficial en el portal de internet de la <u><a href="https://www.sgg.chiapas.gob.mx/" target="_blank" class="resaltado-vino">Secretaría General de Gobierno</a></u>, o en su caso en la versión impresa en el órgano de difusión oficial.</h5>
    </div>

    </div>
</template>

<script>
import botonAtras from './../../button-atras'
import atrasComponent from './../../reload.vue'
import leyesDecretosCollapse from './Leyes-decretos-collapse'
export default {
    mounted(){
        window.scrollTo(0, 0);
    },
    components:{
        atrasComponent,
        leyesDecretosCollapse,
        botonAtras,
    }
}
</script>

<style scoped>
    .title_document {
        padding: .8rem 1rem;
        width: 100%;
        height: auto;
        border: 1px solid#dfdfdf ;
        border-radius: 5px;
        border-left: 3px solid #621132;

        display: flex;
        justify-content: space-between;
        align-items: center !important;
    }

    .title_document:hover{
        box-shadow: 3px 8px 17px -13px rgba(0,0,0,0.75) !important;
    }

    .descargar{
        font-size: 0.9rem;
        color: #6c757d !important;
    }

    /*
    lo cambie a estilos.css
    .subtitulo {
        font-weight: 400;
        font-size: 1.8rem;
        margin-top: 1rem;
    } */
    /*

    .subtitulo2{
        font-weight: 400;
        font-size: 1.2rem;
        margin-top: .5rem;
        margin-bottom: 1rem ;
    } */
    .title_document h5{
        font-size: 0.9rem;
        font-weight: 400;
        /* line-height: 20px; */
    }

    .sec_imagen{
        width:85% !important;
        background-color: #560F2C;
        /* margin-top: 3rem; */
    }

    a{
        text-decoration: none !important;
        color: #212529;
    }
    a:hover{ color:#212529 !important; }

    /* margenes de la card consulta */
    .margenes{
        display: flex;
        justify-content: flex-end;
    }
    .card-width{ width: 90%; }

    /* select */
    .form-control-lg {
        font-size: 1rem;
        border-radius: .4rem;
    }

    .tab-select{
        position: sticky !important;
        top: 15% !important;
        z-index: 1000 !important;
    }

@media only screen and (max-device-width : 900px) {

    .container{
        padding-right: 1% !important;
        padding-left: 1% !important;
    }
    .title_document{
        padding: .5rem 1rem .5rem .1rem;
        line-height: 20px;
    }

    /* margenes de la card consulta */
    .margenes{ justify-content: space-around; }
    .card-width{ width: 95%; }

    .subtitulo2{ font-size: 1rem; }

    .sec_imagen{ margin-top: 0rem; }


    .tab-select{
        position: initial;
        z-index: auto;
    }
}

</style>
